import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CompleteScenarioRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CompleteScenarioResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const completeScenario = (request: CompleteScenarioRequest, options?: CashRequestOptions) =>
  post<CompleteScenarioRequest, CompleteScenarioResponse>('/2.0/cash/complete-scenario', request, {
    ...options,
    rejectOnError: true,
  })
